export const data = {
  "Programming Languages": 86,
  "Data Analysis & Storage": 76,
  "Compiler & Architecture": 54,
  "Software Development": 86,
  "Machine Learning": 61,
  "Visualizations & Graphics": 92,
};

// Add this to your data.js or create a new file
export const skillsDetailData = {
  "Programming Languages": [
    { name: "JavaScript" },
    { name: "C/C++" },
    { name: "Python" },
    { name: "HTML/CSS" },
    { name: "R" },
    { name: "PHP" },
  ],
  "Data Analysis & Storage": [
    { name: "SQL" },
    { name: "MongoDB" },
    { name: "AWS" },
    { name: "PostgreSQL" },
    { name: "Excel VBA" },
  ],
  "Machine Learning": [
    { name: "LLM" },
    { name: "TensorFlow" },
    { name: "PyTorch" },
    { name: "Scikit-learn" },
  ],
  "Visualizations & Graphics": [
    { name: "D3.js" },
    { name: "Matplotlib" },
    { name: "Seaborn" },
    { name: "Leaflet" },
    { name: "Figma" },
  ],
  "Software Development": [
    { name: "Vue" },
    { name: "React" },
    { name: "Svelte" },
    { name: "Node.js" },
    { name: "Flask" },
  ],
  "Compiler & Architecture": [
    { name: "lex&yacc" },
    { name: "gem5" },
    { name: "SIC/XE" },
  ],
};
